<template>
  <div :class="directionClass">
    <slot name="default"></slot>
  </div>
</template>
<script lang="ts">
export const CHECK_BOX_SYMBOL_KEY = Symbol("checkBoxSymbolKey");
export type ProvideType = {
  curValue: any;
  getGroupValue: () => (string | number | boolean)[];
  setGroupValue: (callbackEffect: () => { value: any; isCheck: boolean }) => void;
  getGroupDisabled: () => boolean;
};
</script>
<script setup lang="ts">
import { defineEmits, ref, withDefaults, computed, watch, provide, reactive } from "vue";

const props = withDefaults(
  defineProps<{
    modelValue: (string | number | boolean)[];
    disabled?: boolean;
    direction?: "horizontal" | "vertical"; // 水平还是垂直 默认水平布局
  }>(),
  {
    disabled: false,
    direction: "horizontal",
  }
);

const emits = defineEmits<{
  (e: "update:model-value", value: any): void;
  (e: "change", value: any): void;
}>();

/**
 * 外部的初始值 如何给到子组件，让他们勾选或者不勾选？ 注入一个getRootValue即可
 * 内部状态值，如果给到group组件，让他们向外穿透？ setGroupValue 也许可以
 * 如何修改到内部的disabled状态？ 这或许是个问题。。。 内部状态受到props.disabled 渗透进去，浸入原始disabled
 * 太棒了 ～～～
 */
const curValue = ref<(string | number | boolean)[]>([]);

provide(
  CHECK_BOX_SYMBOL_KEY,
  reactive<ProvideType>({
    curValue,
    getGroupValue: () => curValue.value,
    getGroupDisabled: () => props.disabled,
    setGroupValue: (callbackEffect) => {
      const { value, isCheck } = callbackEffect();
      const isExistIndex = curValue.value.findIndex((item) => item === value);
      if (isCheck) {
        // 选中
        if (isExistIndex < 0) {
          // 之前没有的话
          curValue.value.push(value);
        }
        // 之前有的话，就算了
      } else {
        // 取消
        if (isExistIndex > -1) {
          // 之前存在，干掉
          curValue.value.splice(isExistIndex, 1);
        }
        // 之前不存在，就算了
      }
      const newValue = curValue.value;
      emits("update:model-value", newValue);
      emits("change", newValue);
    },
  })
);

const directionClass = computed(() => {
  return props.direction === "horizontal" ? "flex-row" : "flex-column";
});

watch(
  () => props.modelValue,
  (newValue) => {
    if (newValue && Array.isArray(newValue)) {
      curValue.value = newValue;
    } else {
      curValue.value = [];
    }
  },
  { immediate: true }
);
</script>
<style lang="less" scoped>
.flex-row {
  display: flex;
  align-items: center;
}
.flex-column {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>
